import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Translate from 'react-translate-component';
import { find, propEq } from 'ramda';

import { mapIndexed } from 'utils/ramdaAdditions';
import { MonthYearField } from 'components/common/fields/DateTimeFields';
import { openModalPerson } from 'actions/modalActions';
import { OWN_COMPANY } from 'constants/company';

const translatePrefix = 'company.employees.';

@connect(null, { openModalPerson })
export default class EmployeesTable extends Component {
    static propTypes = {
        departments: PropTypes.array.isRequired,
        employees: PropTypes.array.isRequired,
        companyType: PropTypes.string.isRequired,
        openModalPerson: PropTypes.func.isRequired,
    }

    getDepartmentById = (id) => {
        const department = find(propEq('id', id))(this.props.departments);
        return department ? department.name : "";
    };

    renderHeader = (companyType) => (
        <thead>
            <tr>
                <th><Translate content={translatePrefix + 'fullName'} /></th>
                <th><Translate content={translatePrefix + 'position'} /></th>
                <th><Translate content={translatePrefix + 'department'} /></th>
                { companyType === OWN_COMPANY && (
                    <th><Translate content={translatePrefix + 'workDate'} /></th>
                )}
            </tr>
        </thead>
    );

    renderBody = (companyType) => (
        <tbody>
            { mapIndexed((item, rowIndex) => (
                <tr key={rowIndex}>
                    <td>
                        <a onClick={() => this.props.openModalPerson({ id: item.id, value: item.name })}>
                            {item.name}
                        </a>
                    </td>
                    <td>{item.position}</td>
                    <td>{this.getDepartmentById(item.departmentId)}</td>
                    { companyType === OWN_COMPANY && (
                        <td>
                            <MonthYearField date={item.beginWork} />
                        </td>
                    )}
                </tr>
            ), this.props.employees)}
        </tbody>
    );

    render () {
        const { companyType } = this.props;

        return (
            <table className="employees-table">
                { this.renderHeader(companyType) }
                { this.renderBody(companyType) }
            </table>
        );
    }
}
